import React from 'react';
import { cn } from '../../utils/cn';

export interface ResponsiveDataViewProps {
  desktop: React.ReactNode;
  mobile: React.ReactNode;
  desktopLabel: string;
  mobileLabel: string;
  className?: string;
}

export function ResponsiveDataView({
  desktop,
  mobile,
  desktopLabel,
  mobileLabel,
  className,
}: ResponsiveDataViewProps) {
  return (
    <div className={cn('w-full', className)}>
      <div role="region" aria-label={desktopLabel} className="hidden overflow-x-auto lg:block">
        {desktop}
      </div>
      <div role="region" aria-label={mobileLabel} className="grid gap-3 lg:hidden">
        {mobile}
      </div>
    </div>
  );
}
